import React, { useState, useEffect, useRef, ChangeEvent } from "react";
import Header from "../../../components/molecules/Header/Header";
import Banner from "../../../components/layout/Sections/Banner";
import { Container, Row, Col } from "react-bootstrap";
import Footer from "../../../components/molecules/Footer/Footer";
import { getCountries } from "../../../api/apimethods";
import "../../../styles/styles.css";
import ReCAPTCHA from "react-google-recaptcha";
import { useConfig } from "../../../context/ConfigProvider";
import { ICodeMasterModel } from "../../../../src/typings/models/CodeMasterModel";
function ApplicationForMembership() {
  const bannerName = "Application for Membership under ACS/TPS/BSAA";
  const [applicantType, setApplicantType] = useState("Individual");
  const [salutation, setSalutation] = useState("Mr");
  const [applicantName, setApplicantName] = useState("");
  const [identificationType, setIdentificationType] = useState("NRIC");
  const [identificationNumber, setIdentificationNumber] = useState("");
  const [uenNumber, setUenNumber] = useState("");
  const [citizenship, setCitizenship] = useState("");
  const [gender, setGender] = useState("Male");
  const [dob, setDob] = useState("");
  const [designation, setDesignation] = useState("List of designations");
  const [otherDesignation, setOtherDesignation] = useState("");
  const [officeTelNumber, setOfficeTelNumber] = useState("");
  const [homeTelNumber, setHomeTelNumber] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [alternativeEmail, setAlternativeEmail] = useState("");
  const [primaryContactMode, setPrimaryContactMode] = useState("Mobile Number");
  const [receiveStatusUpdates, setReceiveStatusUpdates] = useState(false);
  const [organizationName, setOrganizationName] = useState("");
  const [organizationUenNumber, setOrganizationUenNumber] = useState("");
  const [organizationType, setOrganizationType] = useState("Sole Proprietor");
  const [formerRegistrationNumber, setFormerRegistrationNumber] = useState("");
  const [orgAddressType, setOrgAddressType] = useState("Local");
  const [premisesType, setPremisesType] = useState("Office");
  const [postalCode, setPostalCode] = useState("");
  const [error, seterror] = useState("");
  const [blockNumber, setBlockNumber] = useState("");
  const [streetName, setStreetName] = useState("");
  const [floorNumber, setFloorNumber] = useState("");
  const [unitNumber, setUnitNumber] = useState("");
  const [buildingName, setBuildingName] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [countries, setCountries] = useState<ICodeMasterModel[]>([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedCertification, setSelectedCertification] = useState("");
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const recaptchaRef = useRef<ReCAPTCHA | null>(null);
  const cfg = useConfig();
  const site_Key: string = cfg.REACT_APP_SITE_KEY ?? "";
  const allowedExtensions = [
    "pdf",
    "docx",
    "doc",
    "jpg",
    "jpeg",
    "png",
    "xlsx",
    "xls",
    "ppt",
  ];
  const [schemeManual, setSchemeManual] = useState<File | null>(null);
  const [fumigatorCertification, setFumigatorCertification] =
    useState<File | null>(null);
  const [isoAccreditation, setIsoAccreditation] = useState<File | null>(null);
  const handleFileChange = (
    event: ChangeEvent<HTMLInputElement>,
    setFileState: React.Dispatch<React.SetStateAction<File | null>>
  ) => {
    const fileInput = event.target;

    if (fileInput && fileInput.files && fileInput.files.length > 0) {
      const file = fileInput.files[0];
      const fileExtension = file.name.split(".").pop()?.toLowerCase();

      if (allowedExtensions.includes(fileExtension as string)) {
        setFileState(file);
        setErrorMessage("");
      } else {
        setFileState(null);
        setErrorMessage(
          `Invalid file extension. Allowed extensions are: ${allowedExtensions.join(
            ", "
          )}`
        );
      }
    } else {
      setFileState(null);
      setErrorMessage("No file selected");
    }
  };

  const handleApplicantTypeChange = (e: ChangeEvent<HTMLInputElement>) => {
    setApplicantType(e.target.value);
  };

  const handleCertificationChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSelectedCertification(e.target.value);
  };

  const handleSalutationChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSalutation(e.target.value);
  };

  const handleDesignationChange = (e: ChangeEvent<HTMLInputElement>) => {
    setDesignation(e.target.value);
  };

  const handlePrimaryContactModeChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPrimaryContactMode(e.target.value);
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await getCountries();
        setCountries(response.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isCaptchaValid) {
      // console.log(
      //   applicantType,
      //   salutation,
      //   applicantName,
      //   identificationType,
      //   identificationNumber,
      //   uenNumber,
      //   citizenship,
      //   gender,
      //   dob,
      //   designation,
      //   otherDesignation,
      //   officeTelNumber,
      //   homeTelNumber,
      //   mobileNumber,
      //   email,
      //   alternativeEmail,
      //   primaryContactMode,
      //   receiveStatusUpdates,
      //   organizationName,
      //   organizationUenNumber,
      //   organizationType,
      //   formerRegistrationNumber,
      //   orgAddressType,
      //   premisesType,
      //   postalCode,
      //   blockNumber,
      //   streetName,
      //   floorNumber,
      //   unitNumber,
      //   buildingName,
      //   country,
      //   state
      // );
    } else {
      console.log(error);
    }
  };

  return (
    <>
      <Header />
      <Container>
        <Banner name={bannerName} uiClass="banner-bg" />
      </Container>
      <Container>
        <Row>
          <Col md={2}>
            <div className="filter-cntt">
              <h3>E-Services</h3>
              <div className="filter-span">Application Details</div>
              <h2>Registration Mode</h2>
              <button title="Dashboard">Dashboard</button>
            </div>
          </Col>

          <Col md={10}>
            <form onSubmit={handleSubmit}>
              <div className="inst-cntt mt-2">
                <label htmlFor="certificationToApply">
                  <h2>Certification to Apply</h2>
                </label>
                <div className="form-checked">
                  <label className="form-check-label" htmlFor="acsRadio">
                    <input
                      type="radio"
                      name="certificationToApply"
                      value="ACS"
                      className="form-check-input"
                      checked={selectedCertification === "ACS"}
                      onChange={handleCertificationChange}
                      required
                    />
                    ACS
                  </label>
                </div>
                <div className="form-checked">
                  <label className="form-check-label" htmlFor="bsaaRadio">
                    <input
                      type="radio"
                      name="certificationToApply"
                      value="BSAA"
                      className="form-check-input"
                      checked={selectedCertification === "BSAA"}
                      onChange={handleCertificationChange}
                      required
                    />
                    BSAA
                  </label>
                </div>

                <div className="form-checked">
                  <label className="form-check-label" htmlFor="tpsRadio">
                    <input
                      type="radio"
                      name="certificationToApply"
                      value="TPS"
                      className="form-check-input"
                      checked={selectedCertification === "TPS"}
                      onChange={handleCertificationChange}
                      required
                    />
                    TPS
                  </label>
                </div>
              </div>
              <div className="inst-cntt mt-2">
                <div>
                  <label htmlFor="applicantType">
                    <h2>Applicant Personal Details</h2>
                    Applicant Type<span className="star-red">*</span>
                  </label>
                  <div className="form-checked">
                    <label
                      className="form-check-label"
                      htmlFor="individualRadio"
                    >
                      <input
                        type="radio"
                        name="applicantType"
                        value="Individual"
                        className="form-check-input"
                        checked={applicantType === "Individual"}
                        onChange={handleApplicantTypeChange}
                        required
                      />
                      Individual
                    </label>
                  </div>
                  <div className="form-checked">
                    <label
                      className="form-check-label"
                      htmlFor="organizationRadio"
                    >
                      <input
                        type="radio"
                        name="applicantType"
                        value="Organization"
                        className="form-check-input"
                        checked={applicantType === "Organization"}
                        onChange={handleApplicantTypeChange}
                        required
                      />
                      Organization
                    </label>
                  </div>

                  <label className="form-check-label">
                    Salutation<span className="star-red">*</span>
                    <select
                      value={salutation}
                      onChange={handleSalutationChange}
                      className="form-controll"
                      required
                    >
                      <option value="" disabled hidden>
                        Choose a Salutation
                      </option>
                      <option value="Dr">Dr</option>
                      <option value="Mdm">Mdm</option>
                      <option value="Miss">Miss</option>
                      <option value="Mr">Mr</option>
                      <option value="Mrs">Mrs</option>
                    </select>
                  </label>

                  <label className="form-check-label">
                    Applicant Name<span className="star-red">*</span>
                    <input
                      type="text"
                      value={applicantName}
                      className="form-controll"
                      onChange={(e) => setApplicantName(e.target.value)}
                      maxLength={255}
                      required
                    />
                  </label>

                  <label
                    className="form-check-label"
                    htmlFor="identificationType"
                  >
                    Identification Type<span className="star-red">*</span>
                  </label>
                  <div className="form-checked">
                    <label className="form-check-label">
                      <input
                        type="radio"
                        name="identificationType"
                        value="NRIC"
                        className="form-check-input"
                        checked={identificationType === "NRIC"}
                        onChange={() => setIdentificationType("NRIC")}
                        required
                      />
                      NRIC
                    </label>
                  </div>
                  <div className="form-checked">
                    <label className="form-check-label">
                      <input
                        type="radio"
                        name="identificationType"
                        value="FIN"
                        className="form-check-input"
                        checked={identificationType === "FIN"}
                        onChange={() => setIdentificationType("FIN")}
                        required
                      />
                      FIN
                    </label>
                  </div>
                  <div className="form-checked">
                    <label className="form-check-label">
                      <input
                        type="radio"
                        name="identificationType"
                        value="Passport"
                        className="form-check-input"
                        checked={identificationType === "Passport"}
                        onChange={() => setIdentificationType("Passport")}
                        required
                      />
                      Passport No
                    </label>
                  </div>

                  <label className="form-check-label">
                    Identification Number<span className="star-red">*</span>
                    <input
                      type="text"
                      className="form-controll"
                      value={identificationNumber}
                      onChange={(e) => setIdentificationNumber(e.target.value)}
                      required
                    />
                  </label>

                  <label className="form-check-label">
                    UEN Number
                    <input
                      type="text"
                      value={uenNumber}
                      className="form-controll"
                      onChange={(e) => setUenNumber(e.target.value)}
                      maxLength={9}
                    />
                  </label>

                  <label className="form-check-label">
                    Citizenship<span className="star-red">*</span>
                    <input
                      type="text"
                      value={citizenship}
                      onChange={(e) => setCitizenship(e.target.value)}
                      maxLength={255}
                      className="form-controll"
                      required
                    />
                  </label>

                  <div className="form-checked">
                    <label className="form-check-label">
                      {" "}
                      Gender<span className="star-red">*</span>
                    </label>

                    <label className="form-check-label">
                      <input
                        type="radio"
                        name="gender"
                        value="Male"
                        className="form-check-input"
                        checked={gender === "Male"}
                        onChange={() => setGender("Male")}
                        required
                      />
                      Male
                    </label>
                  </div>
                  <div className="form-checked">
                    <label className="form-check-label">
                      <input
                        type="radio"
                        name="gender"
                        value="Female"
                        className="form-check-input"
                        checked={gender === "Female"}
                        onChange={() => setGender("Female")}
                        required
                      />
                      Female
                    </label>
                  </div>

                  <label className="form-check-label">
                    Date of Birth<span className="star-red">*</span>
                    <input
                      type="date"
                      value={dob}
                      className="form-controll"
                      onChange={(e) => setDob(e.target.value)}
                      required
                    />
                  </label>

                  <div className="form-checked">
                    <label className="form-check-label">Designation</label>
                    <input
                      type="radio"
                      name="designation"
                      value="List of designations"
                      className="form-check-input"
                      checked={designation === "List of designations"}
                      onChange={() => setDesignation("List of designations")}
                    />
                    List of designations
                  </div>
                  <div className="form-checked">
                    <label>
                      <input
                        type="radio"
                        name="designation"
                        value="Other"
                        className="form-check-input"
                        checked={designation === "Other"}
                        onChange={() => setDesignation("Other")}
                      />
                      Others
                    </label>
                    {designation === "Other" && (
                      <div>
                        <label htmlFor="otherDesignation">
                          Other Designation:
                        </label>
                        <input
                          type="text"
                          value={otherDesignation}
                          onChange={(e) => setOtherDesignation(e.target.value)}
                          maxLength={255}
                        />
                      </div>
                    )}
                  </div>

                  <label className="form-check-label">
                    Office Tel Number
                    <input
                      type="text"
                      value={officeTelNumber}
                      className="form-controll"
                      onChange={(e) => setOfficeTelNumber(e.target.value)}
                      maxLength={16}
                    />
                  </label>

                  <label className="form-check-label">
                    Home Tel Number
                    <input
                      type="text"
                      value={homeTelNumber}
                      className="form-controll"
                      onChange={(e) => setHomeTelNumber(e.target.value)}
                      maxLength={16}
                    />
                  </label>

                  <label className="form-check-label">
                    Mobile Number<span className="star-red">*</span>
                    <input
                      type="text"
                      value={mobileNumber}
                      className="form-controll"
                      onChange={(e) => setMobileNumber(e.target.value)}
                      maxLength={16}
                      required
                    />
                  </label>

                  <label className="form-check-label">
                    Email<span className="star-red">*</span>
                    <input
                      type="email"
                      value={email}
                      className="form-controll"
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </label>

                  <label className="form-check-label">
                    Alternative Email
                    <input
                      type="email"
                      className="form-controll"
                      value={alternativeEmail}
                      onChange={(e) => setAlternativeEmail(e.target.value)}
                    />
                  </label>

                  <div className="form-checked">
                    <label className="form-check-label">
                      Primary Contact Mode<span className="star-red">*</span>
                    </label>
                    <label className="form-check-label">
                      <input
                        type="radio"
                        name="primaryContactMode"
                        className="form-check-input"
                        value="Mobile Number"
                        checked={primaryContactMode === "Mobile Number"}
                        onChange={() => setPrimaryContactMode("Mobile Number")}
                        required
                      />
                      Mobile Number
                    </label>
                  </div>
                  <div className="form-checked">
                    <label className="form-check-label">
                      <input
                        type="radio"
                        name="primaryContactMode"
                        value="Email"
                        className="form-check-input"
                        checked={primaryContactMode === "Email"}
                        onChange={() => setPrimaryContactMode("Email")}
                        required
                      />
                      Email
                    </label>
                  </div>

                  <label>
                    <input
                      type="checkbox"
                      checked={receiveStatusUpdates}
                      onChange={() =>
                        setReceiveStatusUpdates(!receiveStatusUpdates)
                      }
                      required
                    />
                    &nbsp; Tick if you prefer to receive status updates of
                    licence application via SMS
                  </label>
                </div>
              </div>
              <div className="inst-cntt mt-2">
                <h2>Applicant Organisation Details & Address</h2>
                <br />
                <label className="form-check-label">
                  Organization Name
                  <input
                    type="text"
                    value={organizationName}
                    onChange={(e) => setOrganizationName(e.target.value)}
                    maxLength={255}
                    className="form-controll"
                  />
                </label>
                <label className="form-check-label">
                  UEN Number
                  <input
                    type="text"
                    value={organizationUenNumber}
                    onChange={(e) => setOrganizationUenNumber(e.target.value)}
                    maxLength={9}
                    className="form-controll"
                  />
                </label>
                <label className="form-check-label">
                  Organization Type
                  <select
                    value={organizationType}
                    className="form-controll"
                    onChange={(e) => setOrganizationType(e.target.value)}
                  >
                    <option value="Sole Proprietor">Sole Proprietor</option>
                    <option value="Ordinary Business">Ordinary Business</option>
                    <option value="Limited Partnership">
                      Limited Partnership
                    </option>
                    <option value="Limited Liability Partnership">
                      Limited Liability Partnership
                    </option>
                    <option value="Private Company Limited By Shares">
                      Private Company Limited By Shares
                    </option>
                  </select>
                </label>
                <label className="form-check-label">
                  Former Business/Company Registration Number
                  <input
                    type="text"
                    className="form-controll"
                    value={formerRegistrationNumber}
                    onChange={(e) =>
                      setFormerRegistrationNumber(e.target.value)
                    }
                    maxLength={9}
                  />
                </label>
                <div className="form-checked">
                  <label className="form-check-label">
                    Organisational Address Type
                  </label>
                  <div className="form-checked">
                    <label className="form-check-label">
                      <input
                        type="radio"
                        name="orgAddressType"
                        value="Local"
                        className="form-check-input"
                        checked={orgAddressType === "Local"}
                        onChange={() => setOrgAddressType("Local")}
                      />
                      Local
                    </label>
                  </div>
                  <div className="form-checked">
                    <label className="form-check-label">
                      <input
                        type="radio"
                        name="orgAddressType"
                        value="Foreign"
                        className="form-check-input"
                        checked={orgAddressType === "Foreign"}
                        onChange={() => setOrgAddressType("Foreign")}
                      />
                      Foreign
                    </label>
                  </div>
                </div>

                <div>
                  <div className="form-checked">
                    <label className="form-check-label">
                      Type of Premises{" "}
                    </label>
                    <div className="form-checked">
                      <label className="form-check-label">
                        <input
                          type="radio"
                          name="premisesType"
                          value="Office"
                          className="form-check-input"
                          checked={premisesType === "Office"}
                          onChange={() => setPremisesType("Office")}
                        />
                        Office
                      </label>
                    </div>
                    <div className="form-checked">
                      <label className="form-check-label">
                        <input
                          type="radio"
                          name="premisesType"
                          value="Home"
                          className="form-check-input"
                          checked={premisesType === "Home"}
                          onChange={() => setPremisesType("Home")}
                        />
                        Home
                      </label>
                    </div>
                    <div className="form-checked">
                      <label className="form-check-label">
                        <input
                          type="radio"
                          name="premisesType"
                          value="Others"
                          className="form-check-input"
                          checked={premisesType === "Others"}
                          onChange={() => setPremisesType("Others")}
                        />
                        Others
                      </label>
                    </div>
                  </div>
                </div>
                <label className="form-check-label">
                  Postal Code<span className="star-red">*</span>
                  <input
                    type="text"
                    className="form-controll"
                    value={postalCode}
                    onChange={(e) => setPostalCode(e.target.value)}
                    maxLength={6}
                    required
                  />
                </label>
                <label className="form-check-label">
                  Block/House Number
                  <input
                    type="text"
                    className="form-controll"
                    value={blockNumber}
                    onChange={(e) => setBlockNumber(e.target.value)}
                    maxLength={10}
                  />
                </label>
                <label className="form-check-label">
                  Street Name
                  <input
                    type="text"
                    className="form-controll"
                    value={streetName}
                    onChange={(e) => setStreetName(e.target.value)}
                    maxLength={32}
                  />
                </label>
                <label className="form-check-label">
                  Floor Number
                  <input
                    type="text"
                    className="form-controll"
                    value={floorNumber}
                    onChange={(e) => setFloorNumber(e.target.value)}
                    maxLength={3}
                  />
                </label>
                <label className="form-check-label">
                  Unit Number
                  <input
                    type="text"
                    value={unitNumber}
                    className="form-controll"
                    onChange={(e) => setUnitNumber(e.target.value)}
                    maxLength={5}
                  />
                </label>
                <label className="form-check-label">
                  Building Name
                  <input
                    type="text"
                    value={buildingName}
                    className="form-controll"
                    onChange={(e) => setBuildingName(e.target.value)}
                    maxLength={66}
                  />
                </label>
                <div>
                  <label className="form-check-label" htmlFor="country">
                    Country<span className="star-red">*</span>
                  </label>
                  <select
                    id="country"
                    name="country"
                    value={country}
                    className="form-controll"
                    onChange={(e) => setCountry(e.target.value)}
                    required
                  >
                    {" "}
                    <option value="" disabled hidden>
                      Choose a Country
                    </option>
                    {countries.map((country) => (
                      <option key={country.id} value={country.name}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </div>
                <label className="form-check-label">
                  State<span className="star-red">*</span>
                  <input
                    type="text"
                    value={state}
                    className="form-controll"
                    onChange={(e) => setState(e.target.value)}
                    maxLength={32}
                    required
                  />
                </label>
              </div>
              <div className="inst-cntt mt-2">
                <h2>Application Supporting Files</h2>
                <br />
                <label className="form-check-label">
                  <h6>
                    {" "}
                    Extensions allowed for files: {allowedExtensions.join(", ")}
                  </h6>
                </label>
                <label className="form-check-label">
                  Scheme Manual <span className="star-red">*</span>
                </label>
                <div>
                  <input
                    type="file"
                    className="form-checked"
                    accept={allowedExtensions.map((ext) => `.${ext}`).join(",")}
                    onChange={(e) => handleFileChange(e, setSchemeManual)}
                  />
                  {schemeManual && (
                    <div>
                      <strong className="greenText">
                        Selected Scheme Manual File:
                      </strong>{" "}
                      {schemeManual.name}
                    </div>
                  )}
                </div>
                <br />
                <div>
                  <label className="form-check-label">
                    Certification of Fumigator from NEA
                  </label>
                  <input
                    type="file"
                    accept={allowedExtensions.map((ext) => `.${ext}`).join(",")}
                    onChange={(e) =>
                      handleFileChange(e, setFumigatorCertification)
                    }
                  />
                  {fumigatorCertification && (
                    <div>
                      <strong className="greenText">
                        Selected Certification of Fumigator from NEA File:
                      </strong>{" "}
                      {fumigatorCertification.name}
                    </div>
                  )}
                </div>
                <br />
                <div>
                  <label className="form-check-label">ISO Accreditation:</label>
                  <input
                    type="file"
                    accept={allowedExtensions.map((ext) => `.${ext}`).join(",")}
                    onChange={(e) => handleFileChange(e, setIsoAccreditation)}
                  />
                  {isoAccreditation && (
                    <div>
                      <strong className="greenText">
                        Selected ISO Accreditation File:
                      </strong>{" "}
                      {isoAccreditation.name}
                    </div>
                  )}
                </div>
              </div>
              <br />
              <div className="inst-cntt mt-2">
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={site_Key}
                  onChange={() => setIsCaptchaValid(true)}
                  onExpired={() => setIsCaptchaValid(false)}
                />
                {submitted && !isCaptchaValid && (
                  <div className="error-message">
                    Please complete the reCAPTCHA verification.
                  </div>
                )}
                <button type="submit">Submit</button>{" "}
              </div>
            </form>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
}

export default ApplicationForMembership;
